<template>
  <a-tooltip
    v-bind="attrs"
    :placement="placement"
    :arrow="props.arrow"
    :color="bgColor"
    :overlay-style="getOverlayStyle"
    :overlay-class-name="`${getOverlayClass} ${getIsWhiteBg} ${
      !!bgColor || !!textColor ? 'custom-color' : ''
    }`"
  >
    <!-- title插槽 -->
    <template #title>
      <slot name="title">
        <ll-html :value="tip" />
      </slot>
    </template>
    <!-- 默认插槽 -->
    <!-- focus trigger 时不套容器 div，让 slot 内容直接作为 a-tooltip 子元素，否则 focus 事件无法触达 -->
    <div
      v-if="useEllipsis || showContainer"
      :class="getContainerClass"
      :style="getContainerStyle"
    >
      <slot>
        <ll-icon icon-name="icon-question" />
      </slot>
    </div>
    <template v-else>
      <slot>
        <ll-icon icon-name="icon-question" />
      </slot>
    </template>
  </a-tooltip>
</template>

<script setup lang="ts">
import { addUnit, createNamespace } from '@ll-plus/utils'
import { useAttrs } from 'vue'

import { computed } from 'vue'
import { tooltipProps } from './tooltip'

// 1.defineOptions
defineOptions({ name: 'LlTooltip' })

// 2.props
const props = defineProps(tooltipProps)
const attrs = useAttrs()

// 3.computes/const
const bem = createNamespace('tooltip')
const bemContainer = createNamespace('container-tooltip')

// 是否显示白色背景
const getIsWhiteBg = computed(() =>
  props.isWhiteBg && !props.bgColor && !props.textColor ? 'is-white-bg' : '',
)

// 根据ellipsis设置设置插槽容器的文字超出样式
const getContainerClass = computed(() => {
  const ellipsisClass = props.ellipsis ? bemContainer.m('ellipsis') : ''
  return `${bemContainer.b()} ${ellipsisClass}`
})
// 设置插槽容器的宽度
const getContainerStyle = computed(() => {
  const width = addUnit(props.width)
  return {
    width: width ? width : '',
    ...props.containerStyle,
  }
})

// 根据ellipsis/width设置设置tip弹窗的类名
const getOverlayClass = computed(() => {
  const ellipsisClass = props.tipEllipsis ? bem.m('ellipsis') : ''
  return `${bem.b()} ${ellipsisClass} ${props.overlayClassName}`
})
// 根据ellipsis/width设置设置tip弹窗的样式
const getOverlayStyle = computed(() => {
  const maxWidth = addUnit(props.maxWidth)
  return {
    WebkitLineClamp: props.tipEllipsis ? props.tipEllipsisLine : 'none',
    'max-width': maxWidth,
    color: props.textColor || '#fff',
    ...props.overlayStyle,
  }
})

const useEllipsis = computed(() => {
  return !!props.ellipsis || !!addUnit(props.width)
})
</script>
